export default __webpack_public_path__ + "i18n/zh-TW.38ac5889bf308d45b484f5905ad24eba.json";